import { RightSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import { shoppingApi } from 'app/src/services/welfareportal'
import { FringeBenefitSpinner } from 'app/src/shared/components'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

export function GiftCardRightPanelSide(props: {
  order: shoppingApi.OrderDetails
  className?: string
  showFringeSpinner?: boolean
  showCredit?: boolean
}) {
  const creditApiResponse = shoppingApi.useCreditGet(
    {},
    {
      enabled: typeof props.showCredit !== 'undefined' && props.showCredit,
      meta: {
        skip404Errors: true,
      },
    },
  )
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  return (
    <div className={props.className ?? RightSideDefaultClassName}>
      <div className='col-span-12 mx-auto pl-12 lg:col-span-6 lg:pl-0'>
        {props.order.variant?.priceDetails && (
          <>
            <div className='h-[28px]'>{t('GiftCard.priceDescription')}</div>
            <div className='mt-4 text-2xl font-bold'>
              {props.order.variant.priceDetails.finalGrossPrice > 0
                ? euroFormatterIt.format(props.order.variant.priceDetails.finalGrossPrice)
                : t('Common.freeAmount')}
            </div>
            {typeof props.showCredit !== 'undefined' && props.showCredit && (
              <div className='mt-4'>
                {t('Common.balanceDescription', {
                  AVAILABLECREDIT: creditApiResponse.data?.creditByServiceCategory?.welfareArt100.available
                    ? euroFormatterIt.format(creditApiResponse.data.creditByServiceCategory.welfareArt100.available)
                    : '-',
                })}
              </div>
            )}
          </>
        )}
      </div>
      {typeof props.showFringeSpinner !== 'undefined' && props.showFringeSpinner && (
        <div className='col-span-12 lg:col-span-6 lg:pl-6'>
          <FringeBenefitSpinner pt={{ title: { hide: true } }} />
        </div>
      )}
    </div>
  )
}
